<section class="wrapper">
  <div class="card">
    <ion-row>
      <ion-col size-lg="5" size="12">
        <form [formGroup]="subscribeForm" (submit)="subscribe()">
          <div class="s_w">
            <ion-segment formControlName="type" value="b2c">
              <ion-segment-button value="b2c">{{ 'subscribe.tenant' | translate }}</ion-segment-button>
              <ion-segment-button value="b2b">{{ 'subscribe.property_owner' | translate }}</ion-segment-button>
            </ion-segment>
          </div>
          <div class="h1">
            <small>{{ 'subscribe.title' | translate }}</small>
            {{ 'subscribe.subtitle' | translate }}
          </div>
          <div class="message" [class.error]="isError" [class.success]="isSuccess">{{message}}</div>
          <div>
            <ion-input fill="outline" mode="md"
                       formControlName="email"
                       [placeholder]="'subscribe.email_placeholder' | translate">
              <ion-button mode="ios" type="submit" slot="end">{{ 'subscribe.subscribe_button' | translate }}</ion-button>
            </ion-input>
          </div>
          <p>{{ 'subscribe.description' | translate }}</p>
        </form>

      </ion-col>
      <ion-col></ion-col>
    </ion-row>
  </div>

</section>
